<template>
  <div>
    <div :style="style">
      <img v-for="(item, index) in landingPages" :key="index" :class="setImgClassName(item)" :ref="setImgRef(item)"
        @click="handleClick(item)" @error="handleImgError" :style="item.url && buttonStyle" :src="item.pic" alt="" />
    </div>
    <adv-cookie-consent v-if="isShowCookie" @showCookieState="handleShowCookieState"
      @cookieConsentHeight="handleCookieHeight" :initOmega="omega" width="450">
    </adv-cookie-consent>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  nextTick,
} from "@vue/composition-api";
import { IMGS_ACCTION_TYPE } from "./config";
import Omega from "@/utils/register/omega";
import { querySet } from "@/utils/url";
import { TResourceItem } from "./type";
import { getOmegaApplySource } from "@/utils/common";
import { setPageId } from '@/utils/register/omega'
import { PAGE_ID } from '@/constants/page-id'

interface LandingPage {
  pic: string;
  action: number;
  url?: string;
}

type ImgRefType = HTMLElement[] | null;

export default defineComponent({
  name: "market-home",
  props: {
    data: {
      type: Object as () => TResourceItem,
      required: true,
      default: null,
    },
  },
  setup(props) {
    performance.mark('home-p4-start')
    const imgHeight = ref(0);
    const cookieHeight = ref(0);
    const isShowCookie = ref(false);
    const isMedia = ref(false);
    const imgRef = ref<ImgRefType>(null);
    const omega = { Omega: window.Omega, params: {} };
    const landingPages = ref([] as Array<LandingPage>);
    const loadError = ref(false);
    const errorMsg = ref('');
    const errorCode = ref('');

    const style = computed(() => {
      return {
        paddingBottom: `${cookieHeight.value + imgHeight.value}px`,
      };
    });

    const buttonStyle = computed(() => {
      return {
        bottom: `${cookieHeight.value}px`,
      };
    });

    function encodeParams(query: { [key: string]: string }) {
      const arr = Object.keys(query);
      if (arr && arr.length > 0) {
        return arr
          .map((item) => `${item}=${encodeURIComponent(query[item])}`)
          .join("&");
      }
      return "";
    }

    function spliceParams(url: string): string {
      const query = querySet;
      const marketParams = encodeParams(query);
      return `${url}${url.includes("?") ? "&" : "?"}${marketParams}`;
    }

    function handleImgError(e: Event) {
      const target = e.target as HTMLImageElement;
      errorMsg.value = 'Image load failed';
      errorCode.value = 'IMG_LOAD_ERROR';
      loadError.value = true;
      Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_fail_sw", {
        error_msg: errorMsg.value,
        error_code: errorCode.value,
        apply_source: getOmegaApplySource(),
      });
    }

    function handleClick(config: LandingPage) {
      const { action, url } = config;
      if (action === IMGS_ACCTION_TYPE["JUMP"] && url) {
        Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_ck", {
          button_name: 'next',
          apply_source: getOmegaApplySource(),
        });
        window.open(spliceParams(url), "_blank");
      }
    }

    function handleShowCookieState(event: CustomEvent) {
      if (!event.detail) {
        cookieHeight.value = 0;
      }
    }

    function handleCookieHeight(event: CustomEvent) {
      cookieHeight.value = event.detail;
    }

    function setImgRef(item: LandingPage) {
      const { action } = item;
      return action === IMGS_ACCTION_TYPE["JUMP"] ? "imgRef" : "";
    }

    function setImgClassName(item: LandingPage) {
      const { action } = item;
      return action === IMGS_ACCTION_TYPE["JUMP"]
        ? ["outbound-img", "jump-img"]
        : "outbound-img";
    }

    function init() {
      const env = window?.adv?.getEnv();
      const { landing_backgrounds, switcher } = props.data || {};
      landingPages.value = landing_backgrounds || [];
      isShowCookie.value = switcher?.cookie;
      isMedia.value = switcher?.media;
      if (isMedia.value && env) {
        window?.adv?.mediaEventUp(5001, {
          env,
          pixelUp: true,
          httpUp: true,
          data: {},
        });
      }
      performance.mark('home-p4-end')
    }

    init();

    onMounted(() => {
      setPageId(PAGE_ID.MARKET_HOME);
      Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_sw", {
        apply_source: getOmegaApplySource(),
      });
      nextTick(() => {
        if (imgRef.value && imgRef.value[0]) {
          imgRef.value[0].onload = (e: any) => {
            imgHeight.value = e.target?.clientHeight;
          };
          imgRef.value[0].onerror = () => {
            errorMsg.value = 'Image load failed';
            errorCode.value = 'IMG_LOAD_ERROR';
            loadError.value = true;
            Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_fail_sw", {
              error_msg: errorMsg.value,
              error_code: errorCode.value,
              apply_source: getOmegaApplySource(),
            });
          };
        }
      });
    });

    return {
      omega,
      style,
      isMedia,
      isShowCookie,
      landingPages,
      handleClick,
      handleImgError,
      handleShowCookieState,
      handleCookieHeight,
      setImgRef,
      setImgClassName,
      buttonStyle,
      imgRef,
    };
  },
});
</script>
<style scoped>
.outbound-img {
  width: 100%;
  height: auto;
}

.jump-img {
  width: 750px;
  height: auto;
  position: fixed;
}

img {
  display: block;
}
</style>

